import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "@/reducers";
import Sagas from "@/sagas";

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

/**
 * Creates and configures the Redux store with saga middleware.
 *
 * @param initialState - The optional initial Redux state.
 * @returns The configured Redux store.
 */
export function configureStore(initialState = undefined) {
    const store = createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middlewares)),
    );

    sagaMiddleware.run(Sagas);
    return store;
}
